import React from 'react';

import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';
import { Grid, Typography, Link, fade } from '@material-ui/core';

import infographic from '../../assets/before-after.png';

import * as link from '../../utilities/link-config';

const useStyles = makeStyles((theme) => ({
    // [theme.breakpoints.up('xs')]: {}
    // [theme.breakpoints.up('sm')]: {}
    // [theme.breakpoints.up('md')]: {}
    // [theme.breakpoints.up('xl)]: {}
    root: {
        padding: theme.spacing(4),
        color: theme.palette.grey[700]
    },
    nanoMeet: {
        color: theme.palette.primary.main,
        fontWeight: 700,
    },
    header: {
        color: theme.palette.secondary.main,
        marginBottom: theme.spacing(2),
        fontWeight: 300,
        [theme.breakpoints.up('xs')]: {
            fontSize: theme.typography.h5.fontSize

        },
        [theme.breakpoints.up('sm')]: {
            fontSize: theme.typography.h4.fontSize
        },
    },
    center: {
        textAlign: 'center',
        display: 'block',
    },
    description: {
        fontSize: theme.typography.h6.fontSize,
        fontWeight: 400
    },
    image: {
        maxWidth: '100%',
        width: 800
    },
    factWrapper: {
        marginTop: theme.spacing(1),
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        flexWrap: 'wrap'
    },
    fact: {
        fontSize: theme.typography.body1.fontSize,
        margin: theme.spacing(0.5),
        padding: theme.spacing(0.5),
        backgroundColor: fade(theme.palette.primary.main, 0.2),
        color: theme.palette.primary.main,
        borderRadius: theme.spacing(0.5),
        border: '1px solid'
    },
    logo: {
        height: 100,
        marginTop: theme.spacing(1)
    }
}))


export default function What(props) {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Grid
                container
                direction="column"
                justify="center"
                alignItems="center"
            >
                <Grid item xs={12} sm={8}>
                    <Typography className={clsx(classes.center, classes.header)} variant="h4">
                        <span className={classes.nanoMeet}>nanoMeet</span> is a secure browser-based live video and collaboration platform, seamlessly integrated into <Link target="blank" href={link.INFO}><span className={classes.nanoMeet}>nanoStream Cloud</span></Link>, for interactive live streaming. <br />
                        Create, host and broadcast video meetings and events using your own corporate design and interact with your large audience.
                    </Typography>
                </Grid>
                <div className={classes.factWrapper}>
                    {
                        ["GDPR compliant"].map((fact) => (
                            <div key={fact} >
                                <Typography className={classes.fact} variant="overline">
                                    {fact}
                                </Typography>
                            </div>
                        ))
                    }
                </div>
                <Grid item xs={12}>
                    <img className={classes.image} src={infographic} />
                </Grid>
            </Grid>
        </div >
    )
}